import axios from 'axios';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { commonModels } from '..';

export const useOpenStreetMap = (props?: { search?: string }) =>
  useQuery<commonModels.IOpenStreetMap[]>({
    queryKey: ['open-street-map', props?.search],
    queryFn: async () => {
      const res = await axios.get(
        stringifyUrl({
          url: 'https://nominatim.openstreetmap.org/search.php',
          query: {
            q: props?.search,
            polygon_geojson: 1,
            format: 'jsonv2'
          }
        })
      );

      return res?.data;
    },
    enabled: !!props?.search
  });
